// ZL Modal system
if (!window.zlOpenSheet) {
  window.zlOpenSheet = function(id) {
    var modal = document.getElementById(id);
    var overlay = document.getElementById(id + '-overlay');
    if (!modal || !overlay) return;
    modal.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var startY = 0;
    function onTouchStart(e) { startY = e.touches[0].clientY; }
    function onTouchEnd(e) {
      if (e.changedTouches[0].clientY - startY > 60) window.zlCloseSheet(id);
      modal.removeEventListener('touchstart', onTouchStart);
      modal.removeEventListener('touchend', onTouchEnd);
    }
    modal.addEventListener('touchstart', onTouchStart, { passive: true });
    modal.addEventListener('touchend', onTouchEnd);
  };
  window.zlCloseSheet = function(id) {
    var modal = document.getElementById(id);
    var overlay = document.getElementById(id + '-overlay');
    if (modal) modal.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    if (!document.querySelector('.zl-modal.is-open')) {
      document.body.style.overflow = '';
    }
  };
  document.addEventListener('click', function(e) {
    var el = e.target.closest('[data-zl-close]');
    if (el) window.zlCloseSheet(el.getAttribute('data-zl-close'));
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.zl-modal.is-open').forEach(function(m) {
        window.zlCloseSheet(m.id);
      });
    }
  });

  // Accordion toggle (overview_row / highlights_row)
  window.zlToggleAcc = function(trigger) {
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    var bodyId   = trigger.getAttribute('aria-controls');
    var body     = bodyId ? document.getElementById(bodyId) : null;
    if (!body) return;
    trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    if (expanded) {
      body.hidden = true;
    } else {
      body.hidden = false;
    }
  };
}